<script setup lang="ts">
withDefaults(defineProps<{ showDescription?: boolean }>(), {showDescription: true})
</script>
<template>
  <div class="flex items-center gap-4">
    <img src="@/assets/images/logo.png" alt="logo"/>
    <div v-text="'منصة المهندس أحمد جمال حسن'" :class="{'hidden md:block':!showDescription}"/>
  </div>
</template>
